import * as Inovx from '@shared';
import GraphicSourceConstants from './../constants/GraphicSourceConstants';
import GraphicSourceServices from '../services/GraphicSourceServices';
import FacilityStore from '../stores/FacilityStore';
var SystemActions = Inovx.Shared.System.Actions;
var SystemStore = Inovx.Shared.System.Store;
var FormHelper = Inovx.Shared.Common.FormHelper;
var UrlUtilities = Inovx.Shared.Common.UrlUtilities;

function _sendInvalidSave() {
    Inovx.Shared.Flux.AppDispatcher.dispatch({
        actionType: GraphicSourceConstants.GRAPHIC_SOURCE_INVALID_ADD
    });
}

var GraphicSourceActions = {
    beginAdd(): void {
        Inovx.Shared.Flux.AppDispatcher.dispatch({
            actionType: GraphicSourceConstants.GRAPHIC_SOURCE_ADD
        });
    },
    beginEdit(data: IKnowledgeBook): void {
        Inovx.Shared.Flux.AppDispatcher.dispatch({
            actionType: GraphicSourceConstants.GRAPHIC_SOURCE_EDIT,
            data
        });
    },
    updateGraphicSourceObject(data: IGraphicSource): void {
        Inovx.Shared.Flux.AppDispatcher.dispatch({
            actionType: GraphicSourceConstants.GRAPHIC_SOURCE_UPDATE_OBJECT,
            data
        });
    },
    closeGraphicSourceModal(): void {
        Inovx.Shared.Flux.AppDispatcher.dispatch({
            actionType: GraphicSourceConstants.GRAPHIC_SOURCE_MODAL_CLOSE,
        });
    },
    async getGraphicSources(facilityID: string) {
        //const data = await GraphicSourceServices.getGraphicSources(facilityID);
        const data: IGraphicSource[] = []; // DISABLED!
        if (data.length > 0) data.sort((a, b) => a.Name.localeCompare(b.Name));
        Inovx.Shared.Flux.AppDispatcher.dispatch({
            actionType: GraphicSourceConstants.GRAPHIC_SOURCES,
            data
        });

        return data;
    },
    async createGraphicSource(graphicSource: IGraphicSource) {
        {
            if (!SystemStore.isActionInProgress(GraphicSourceConstants.GRAPHIC_SOURCE_ADD)) {
                SystemActions.beginAction(GraphicSourceConstants.GRAPHIC_SOURCE_ADD);

                try {
                    const template = graphicSource;
                    let data = FormHelper.trim(template);
                    var form_data: any = new FormData();
                    form_data.append("ID", data.ID)
                    form_data.append("Name", data.Name)
                    form_data.append("FacilityID", data.FacilityID)
                    if (template.GraphicsFileData) form_data.append("GraphicsFileData", template.GraphicsFileData, "export.glb");
                    form_data.append("Scale", data.Scale)
                    form_data.append("Rotation", data.Rotation)
                    if (data.Position) {
                        form_data.append("Position.X", data.Position.X)
                        form_data.append("Position.Y", data.Position.Y)
                        form_data.append("Position.Z", data.Position.Z)
                    }
                    if (data.ExtentsMax) {
                        form_data.append("ExtentsMax.X", data.ExtentsMax.X)
                        form_data.append("ExtentsMax.Y", data.ExtentsMax.Y)
                        form_data.append("ExtentsMax.Z", data.ExtentsMax.Z)
                    }
                    if (data.ExtentsMin) {
                        form_data.append("ExtentsMin.X", data.ExtentsMin.X)
                        form_data.append("ExtentsMin.Y", data.ExtentsMin.Y)
                        form_data.append("ExtentsMin.Z", data.ExtentsMin.Z)
                    }

                    //if (template.GraphicsFileData) form_data.append("GraphicsFileData", template.GraphicsFileData, "export.glb");
                    form_data.append("VersionToken", data.VersionToken)

                    let res: any = await GraphicSourceServices.createGraphicSource(form_data);
                    res = JSON.parse(res)

                    res.GraphicsFileUrl = (res.GraphicsFileUrl) ? UrlUtilities.getBaseApplicationUrl() + res.GraphicsFileUrl : null;

                    // refresh data
                    this._finishEdit(true);
                    return res;
                }
                finally {
                    this.getGraphicSources(graphicSource.FacilityID)
                    SystemActions.endAction(GraphicSourceConstants.GRAPHIC_SOURCE_ADD);
                }
            }
            else {
                //this._sendInvalidSave()
            }
        }
    },

    async updateGraphicSource(graphicSource: IGraphicSource) {
        
        if (!SystemStore.isActionInProgress(GraphicSourceConstants.GRAPHIC_SOURCE_UPDATE)) {
            SystemActions.beginAction(GraphicSourceConstants.GRAPHIC_SOURCE_UPDATE);

            try {
                const template = graphicSource;
                let data = FormHelper.trim(template);
                var form_data: any = new FormData();
                form_data.append("ID", data.ID)
                form_data.append("Name", data.Name)
                form_data.append("FacilityID", data.FacilityID)
                if (template.GraphicsFileData) form_data.append("GraphicsFileData", template.GraphicsFileData, "export.glb");
                form_data.append("Scale", data.Scale)
                form_data.append("Rotation", data.Rotation)
                if (data.Position) {
                    form_data.append("Position.X", data.Position.X)
                    form_data.append("Position.Y", data.Position.Y)
                    form_data.append("Position.Z", data.Position.Z)
                }
                if (data.ExtentsMax) {
                    form_data.append("ExtentsMax.X", data.ExtentsMax.X)
                    form_data.append("ExtentsMax.Y", data.ExtentsMax.Y)
                    form_data.append("ExtentsMax.Z", data.ExtentsMax.Z)
                } else {
                    form_data.append("ExtentsMax.X", 0)
                    form_data.append("ExtentsMax.Y", 0)
                    form_data.append("ExtentsMax.Z", 0)
                }
                if (data.ExtentsMin) {
                    form_data.append("ExtentsMin.X", data.ExtentsMin.X)
                    form_data.append("ExtentsMin.Y", data.ExtentsMin.Y)
                    form_data.append("ExtentsMin.Z", data.ExtentsMin.Z)
                } else {
                    form_data.append("ExtentsMin.X", 0)
                    form_data.append("ExtentsMin.Y", 0)
                    form_data.append("ExtentsMin.Z", 0)
                }

                //if (template.GraphicsFileData) form_data.append("GraphicsFileData", template.GraphicsFileData, "export.glb");
                form_data.append("VersionToken", data.VersionToken)

                let res: any = await GraphicSourceServices.updateGraphicSource(form_data);
                res = JSON.parse(res)

                res.GraphicsFileUrl = (res.GraphicsFileUrl) ? UrlUtilities.getBaseApplicationUrl() + res.GraphicsFileUrl : null;

                // refresh data
                this._finishEdit(true);
                return res;
            }
            finally {
                this.getGraphicSources(graphicSource.FacilityID)
                SystemActions.endAction(GraphicSourceConstants.GRAPHIC_SOURCE_UPDATE);
            }
        }

        else {
                return;
            }
         
    },
    // To Do, change this to string id when facility store changes are made
    async deleteGraphicSource(graphicSource: IGraphicSource) {
        if (!SystemStore.isActionInProgress(GraphicSourceConstants.GRAPHIC_SOURCE_UPDATE)) {
            SystemActions.beginAction(GraphicSourceConstants.GRAPHIC_SOURCE_UPDATE);

            try {
                await GraphicSourceServices.deleteGraphicSource(graphicSource);
            }
            finally {
                this.getGraphicSources(graphicSource.FacilityID)
                SystemActions.endAction(GraphicSourceConstants.GRAPHIC_SOURCE_UPDATE);
            }
        }

        else {
            return;
        }
    },
    _finishEdit(isVisible: boolean = false) {
        Inovx.Shared.Flux.AppDispatcher.dispatch({
            actionType: GraphicSourceConstants.GRAPHIC_SOURCE_FINISH_EDIT,
            isVisible
        });
    }
}

export default GraphicSourceActions;